// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--gutter-small:1.25rem;--gutter-large:2.5rem;--color-primary-dark:#4e4ae3;--color-primary:#5d59ff;--color-primary-light:#aeacff;--color-primary-lighter:#ebf4fd}.app label{text-transform:none!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
